<template>
    <data-table
        action-button-text="دسته‌بندی جدید"
        action-button-icon="add"
        additional-action-button-text="مرتب سازی"
        additional-action-button-icon="icon-transfer"
        show-select
        remove-key="knowledgeBaseCategory"
        export-key="knowledgeBaseCategories"
        settings-key="knowledgeBaseCategories"
        @click:additionalActionButton="sortDialogRef.openDialog()"
        @click:actionButton="addArticleCategoryRef.create()"
        @getList="getList"
        @deleted="system.setKbParentCategories();"
        ref="dataTableRef"
        :rowClick="(item) => addArticleCategoryRef.edit(item)"
        :headers="headers"
        :items="items"
        :loading="loading"
        :totalItems="totalItems"
        :filters="filters"
        :getAllList="getAllList"
    ></data-table>
    <add-article-category ref="addArticleCategoryRef" @getCategoryList="getList(dataTableRef.finalFilters)"></add-article-category>
    <sort-dialog ref="sortDialogRef" @updated="getList(dataTableRef.finalFilters)" type="knowledgeBaseCategory"></sort-dialog>
</template>
<script setup>
import { useApi } from '@/plugins/api';
import { useSystemStore } from '@/stores/system';
import { useTemplateRef } from 'vue';

defineOptions({
    title: "دسته‌بندی مقالات",
    validate(context) {
        return context.system.license.features.kb_core && context.rbac.can('manage knowledge base');
    },
})
const api = useApi();
const system = useSystemStore();
const sortDialogRef = useTemplateRef('sortDialogRef');
const addArticleCategoryRef = useTemplateRef('addArticleCategoryRef');
const dataTableRef = useTemplateRef('dataTableRef');
const loading = ref(false);
const items = ref([]);
const totalItems = ref(0);
const headers = ref([
    {
        title: 'عنوان',
        key: 'name',
        value: (item) => item.name,
        minWidth: 220,
    },
    {
        title: 'دسته‌بندی والد',
        key: 'parent_id',
        value: (item) => item.parent_id && system.kbParentCategories.length ? system.kbParentCategories.find(x => x.id == item.parent_id).name : undefined,
        minWidth: 270,
    },
    {
        title: 'سطح',
        key: 'level',
        value: (item) => item.parent_id ? 'سطح دو' : 'سطح یک',
        minWidth: 160,
    },
    {
        title: 'وضعيت',
        key: 'status',
        value: (item) => item.status ? 'فعال' : 'غیر فعال',
        minWidth: 150,
    },
]);
const filters = ref({
    page: { type: 'hidden', label: 'صفحه', value: 1 },
    perPage: { type: 'hidden', label: 'تعداد آیتم در صفحه', value: 10 },
    keyword_based: { type: 'divider', label: 'بر اساس عنوان', value: null },
    name: { type: 'text', label: 'عنوان', value: null },
    parent_cat_based: { type: 'divider', label: 'بر اساس دسته‌بندی والد', value: null },
    parent_id: { type: 'autocomplete', label: 'دسته‌بندی والد', items: [], value: null },
    status_based: { type: 'divider', label: 'بر اساس وضعیت', value: null },
    status: { type: 'autocomplete', label: 'وضعیت', items: [{name:'فعال',id:'1'},{name:'غیرفعال',id:'0'}], value: null },
})
async function getList(finalFilters, cb = false) {
    loading.value = true;
    await api.knowledgebaseCategoryList(finalFilters).then(async res => {
        if (res && res.status == "OK") {
            items.value = res.data;
            totalItems.value = res.total;
            system.setKbParentCategories().then(() => { filters.value.parent_id.items = system.kbParentCategories });
        }
    }).finally(() => loading.value = false);
    if (cb)
        cb();
}
async function getAllList(finalFilters) {
    let page = 1, data = [];
    while (page) {
        await api.knowledgebaseCategoryList({
            ...finalFilters,
            perPage: 200,
            page: page,
        }).then(async res => {
            if (res && res.status == "OK") {
                data = data.concat(res.data);
                page = page == res.totalPages ? false : page + 1
            } else
                page = false;
        }).catch(() => page = false);
    }
    return data;
}
</script>
